import React, { useEffect, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { List as ListComponent } from 'src/mtska-frontend-app-component'
import { useDataProvider } from 'src/mtska-frontend-data-provider'
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks'
import { useGridApiRef } from '@mui/x-data-grid'
import JSONPretty from 'react-json-pretty'

const dataProviderName = 'audiences/audiencelead'
const moduleName = 'AudienceLeads'

const ListLead = ({ onTotalChange, filters }) => {
	const { t } = useTranslation()
	const apiRef = useGridApiRef()
	const { loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName)

	const [internalModel, setInternalModel] = useState()
	const [listFilterPageSort, setListFilterPageSort] = useState()

	const handleFilterPageSortChange = model => setInternalModel(model)

	useEffect(() => {
		loadAll({})
	}, [])

	const nextFilterPageSort = useMemo(() => {
		const base = internalModel || {}
		// const internalItems = base?.filterModel?.items || []
        const internalItems = [];
		const externalItems = Array.isArray(filters?.items) ? filters.items : []
		const allItems = [...internalItems, ...externalItems]

		if (allItems.length === 0) return null
		const allComplete = allItems.every(
			item => item && item.field && item.operator && item.value !== undefined && item.value !== null && item.value !== ''
		)
		if (!allComplete) return null

		return { ...base, filterModel: { items: allItems, logicOperator: 'and' } }
	}, [internalModel, filters])

	useEffect(() => {
		if (nextFilterPageSort !== null) {
			setListFilterPageSort(nextFilterPageSort)
		}
	}, [nextFilterPageSort])

	useLoadAll({ listFilterPageSort, loadAll, reloadCounter })

	useEffect(() => {
		if (onTotalChange && typeof total === 'number') onTotalChange(total)
	}, [total, onTotalChange])

	return (
		<>
			{/* {<JSONPretty data={listFilterPageSort?.filterModel ?? {}} className="json-wrapper" />} */}
			<ListComponent
				hideTableToolbar={false}
				onFilterPageSortChange={handleFilterPageSortChange}
				enableSelection={false}
				dataProviderName={dataProviderName}
				items={items}
				total={total}
				totalLabel={t('totalLeadsFounded')}
				customHeader={true}
				loading={loading}
				onRowDoubleClick={() => {}}
				apiRef={apiRef}
				title={t(moduleName)}
				isEmbedded={true}
				headerFilters={false}
			/>
		</>
	)
}

export default ListLead
